<ap-selector-select
    [label]="'personSelector.label' | apContent"
    [options]="selectorOptions()"
    [formControl]="control()"
    [selectedOptions]="selectedOptions()"
    [selectionType]="selectionType"
    [multipleTitle]="'personSelector.multiple.title'"
    [multipleText]="'personSelector.multiple.text'"
    [messages]="messages"
    (clicked)="openModal()"
></ap-selector-select>
